import { useEffect } from 'react'
import styled from '@emotion/styled'
import { typography } from '@retailer-platform/shared-components/src/tds'
import { ModalBody, ModalHeader } from '@retailer-platform/shared-components'
import { errors } from '../../../../../utils/error-handling/errors'
import { useDashMessages } from '../../../../../intl/intl.hooks'
import { trackEvent } from '../../../../../utils/events/trackEvent'
import ConfirmationCheckmark from '../../../../../../src/assets/ConfirmationCheckmark.png'
import { useSurvey } from '../../RetailerSatisfactionSurveyContext'
import {
  type RetailerFeedbackSurveyPages,
  type RetailerFeedbackSurveyState,
  type RetailerFeedbackSurveyProps,
} from '../RetailerFeedbackSurveyController'

const SurveyConfirmationImage = styled.img({
  width: '64px',
  height: '64px',
  objectFit: 'contain',
  marginBottom: '16px',
})

const SurveyConfirmationContainer = styled.div({
  ...typography.subtitle,
})

const SurveyConfirmationBody = styled.div({
  ...typography.bodyRegular,
})

const Page2 = () => {
  const messages = useDashMessages({
    title: 'retailerFeedback.userSurvey.page2.title',
    subheading: 'retailerFeedback.userSurvey.page2.subheading',
    body: 'retailerFeedback.userSurvey.page2.body',
  })

  const { error, isSurveySubmitted, toolProps } = useSurvey<
    RetailerFeedbackSurveyPages,
    RetailerFeedbackSurveyState,
    RetailerFeedbackSurveyProps
  >()

  useEffect(() => {
    if (error?.message) {
      errors.captureException(error, 'Retailer Feedback Survey')
      trackEvent({
        id: 'app.retailerFeedback.survey.modal.submit.error',
        description: 'Tracks whenever the retailer feedback survey is submitted with an error',
        data: {
          errorMessage: error?.message,
        },
      })
    }
  }, [error, error?.message])

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (toolProps?.onClose && isSurveySubmitted) {
        toolProps.onClose()
      }
    }, 1500)

    return () => clearTimeout(timeout)
  }, [isSurveySubmitted, toolProps])

  return (
    <>
      <ModalHeader>{messages.title}</ModalHeader>
      <ModalBody
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          paddingBottom: '38px',
        }}
      >
        <SurveyConfirmationImage src={ConfirmationCheckmark} />
        <SurveyConfirmationContainer>{messages.subheading}</SurveyConfirmationContainer>
        <SurveyConfirmationBody>{messages.body}</SurveyConfirmationBody>
      </ModalBody>
    </>
  )
}

export default Page2
